import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useCanUseReporting } from '../hooks/useCanUseReporting';

interface ReportingAccessGateProps {
  children: ReactNode;
}

/**
 * Route guard for `/reporting` (#1400). Sits inside `<ModuleGate module="reporting">`
 * and sends an employee without AI Reporting access (no reportable catalog pack)
 * back to the dashboard instead of a page whose every request would 403.
 * The decision is the server's `can_use_reporting` flag (useCanUseReporting).
 */
export function ReportingAccessGate({ children }: ReportingAccessGateProps) {
  const canUseReporting = useCanUseReporting();

  if (!canUseReporting) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
}
